import React, { useCallback, useRef, useState } from 'react'

// Components
import Filter, { IProps as IFilterProps } from './Filter'
import FilterTrigger from './FilterTrigger'
import Popover from '../Popover'

// Types
import { IconType } from '../icon/IconType'

export interface IProps<V = string>
  extends Omit<IFilterProps<V>, 'onClose' | 'isOpen'> {
  icon?: IconType
  label: string
  disabled?: boolean
  countOverride?: number
  className?: string
}

const FilterButton = <V,>({
  icon,
  label,
  disabled,
  countOverride,
  className,
  ...filterProps
}: IProps<V>): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)

  const handleClose = useCallback(() => setIsOpen(false), [])

  const count = countOverride ?? filterProps.value.length

  return (
    <>
      <FilterTrigger
        ref={triggerRef}
        icon={icon}
        label={label}
        count={count}
        disabled={disabled}
        isOpen={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
        className={className}
      />
      <Popover
        anchor={triggerRef.current}
        isOpen={isOpen}
        onClose={handleClose}
        placement="bottom-start"
        offset={8}
        ariaLabel={label}
      >
        <Filter<V>
          {...filterProps}
          isOpen={isOpen}
          onClose={handleClose}
          ariaLabel={label}
        />
      </Popover>
    </>
  )
}

export default FilterButton
